import { type ApolloClient } from "@apollo/client";
import { type Service } from "@package/ui-gql/index-data-access";
import { EventEmitter } from "../utils/event-emitter";
import { getServices } from "../utils/wall-utils-gql";

type ServiceEngineEvents = {
  "services-updated": (update: Service[]) => void;
};

export class WallEngineServices extends EventEmitter<ServiceEngineEvents> {
  private activating: boolean = false;

  constructor(private readonly client: ApolloClient<object>) {
    super();
  }

  public async activate(): Promise<void> {
    if (this.activating) {
      return;
    }
    this.activating = true;
    console.log("[wall-engine-services] Activating...");

    this.emit("services-updated", await getServices(this.client));

    console.log("[wall-engine-services] Activated");
    this.activating = false;
  }
}
